(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/receiver/corporate.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/receiver/corporate.js');
"use strict";

const {
  ReactIcon,
  ReactCard: {
    Card,
    CardImage,
    CardBody,
    CardGroup
  }
} = svs.ui;
const {
  cdn
} = svs.core.config.data.svsconfig;
const Corporate = _ref => {
  let {
    id
  } = _ref;
  function getLBSite() {
    const domain = "//".concat(window.location.hostname);
    if (domain.indexOf('spela') > 0) {
      return domain;
    } else if (domain.indexOf('www') > 0) {
      return domain.replace('www', 'spela');
    }
    return domain.replace('tur', 'spela');
  }
  return React.createElement("div", {
    className: "grassroots-receiver-details-corporate-container padding-1"
  }, React.createElement("h4", {
    className: "grassroots-receiver-details-corporate-title"
  }, "St\xF6tta f\xF6reningen!"), React.createElement("p", null, "Genom dina spel hos Svenska Spel", ' ', React.createElement("span", {
    className: "f-medium"
  }, "Sport & Casino"), ' ', "eller", ' ', React.createElement("span", {
    className: "f-medium"
  }, "Tur"), ' ', "kan du bidra till din favoritf\xF6rening genom att f\xF6r varje spel samla ihop po\xE4ng som genererar pengar till din f\xF6rening \u2013 It\u2019s a win win!"), React.createElement(CardGroup, {
    className: "grassroots-receiver-details-corporate-image-card"
  }, React.createElement(Card, {
    branding: svs.grassroots.tenant
  }, React.createElement("a", {
    href: "".concat(getLBSite()).concat(svs.core.data.baseUrl, "/forening/").concat(id)
  }, React.createElement(CardImage, {
    alt: "Sport- och casinospel",
    imageHeight: "150px",
    position: "overlay",
    src: "".concat(cdn, "/images/grassroots-shared-2/sport-3x1.webp")
  }, React.createElement(CardBody, {
    className: "grassroots-receiver-details-corporate-divider"
  }, React.createElement("img", {
    alt: "Sport- och casinospel",
    className: "grassroots-receiver-details-corporate-divider-ao-info-image",
    src: "".concat(cdn, "/images/grassroots-shared-2/ao-soc.svg")
  }), React.createElement("span", {
    className: "grassroots-receiver-details-corporate-divider-link-text"
  }, "Sport- och casinospel", React.createElement(ReactIcon, {
    className: "grassroots-receiver-details-corporate-divider-arrow",
    color: "fc-white",
    icon: "arrow-right"
  })))))), React.createElement(Card, {
    branding: svs.grassroots.tenant
  }, React.createElement("a", {
    href: "/tur".concat(svs.core.data.baseUrl, "/forening/").concat(id)
  }, React.createElement(CardImage, {
    alt: "Turspel",
    imageHeight: "150px",
    position: "overlay",
    src: "".concat(cdn, "/images/grassroots-shared-2/tur-3x1.webp")
  }, React.createElement(CardBody, {
    className: "grassroots-receiver-details-corporate-divider"
  }, React.createElement("img", {
    alt: "Turspel",
    className: "grassroots-receiver-details-corporate-divider-ao-info-image",
    src: "".concat(cdn, "/images/grassroots-shared-2/ao-tur.svg")
  }), React.createElement("span", {
    className: "grassroots-receiver-details-corporate-divider-link-text"
  }, "Turspel", React.createElement(ReactIcon, {
    className: "grassroots-receiver-details-corporate-divider-arrow",
    color: "fc-white",
    icon: "arrow-right"
  }))))))));
};
svs.grassroots.components.receiver.corporate = Corporate;

 })(window);